/** * * Asynchronously loads the component for
Other Help
* */ import { lazyLoad } from "utils/loadable";
export const OtherHelp = lazyLoad(
  () => import("./index"),
  (module) => module.OtherHelp
);